import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import classes from './simulator.module.scss';
import { CcfUpArrowIcon } from '@nice-ccf/ui-controls';

interface DropDownProps {
  customerHistoryId?: any;
  isFromContactHistory?: boolean;
  currentValue: string;
  field: string;
  label: string;
  options: string[];
  handleInputChange?: (field: string, value: string) => void;
  handleInputChangeForHistory?: (
    id: string | number,
    field: string,
    value: string,
    isFromContactHistory?: boolean
  ) => void;
  id?: string | number;
  stackName?: string;
}


/**
 * To show the dropdown element which takes the below props
 * @param props - it will have currentValue, field, label for the dropdown, dropdown options and a onchange handler
 * @returns
 * @example
 */
const DropDown: React.FC<DropDownProps> = ({
  customerHistoryId,
  isFromContactHistory = false,
  currentValue: initialValue,
  field,
  label,
  options,
  handleInputChange,
  handleInputChangeForHistory,
  id,
  stackName,
}) => {
  const currentValue = initialValue || options[0];
  
    /**
   * handleChange Event - used to handle input change for contact history
   * @param event - Dropdown
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleChange = (event: { target: { value: string } }) => {
    if (isFromContactHistory && handleInputChangeForHistory) {
      handleInputChangeForHistory(
        customerHistoryId,
        field,
        event.target.value,
        isFromContactHistory
      );
    } else if (handleInputChange) {
      handleInputChange(field, event.target.value);
    }
  };

  const formControlProps = {
    variant: "outlined" as const,
    className: classes.formControl,
    size: isFromContactHistory ? 'small' as const : undefined,
    style: {
      width: isFromContactHistory ? '100%' : undefined,
      marginBottom: isFromContactHistory ? '15px' : undefined,
    },
    id: id?.toString() || 'demo-simple-select',
  };

  const selectProps = {
    labelId: "demo-simple-select-label",
    variant: "outlined" as const,
    sx: {
      '&& fieldset': {
        border: '1px solid #c4c4c4',
      },
    },
    IconComponent: () => (
      <CcfUpArrowIcon className={classes.arrowIconForDropdown} />
    ),
    value: currentValue,
    onChange: handleChange,
    className: classes.input,
    label,
  };

  return (
    <FormControl {...formControlProps}>
      <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
      <Select {...selectProps}>
        {options.map((option: string, index: number) => (
          <MenuItem
            value={option}
            key={index}
            id={`sm_${stackName}_${option}`}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropDown;